export default __webpack_public_path__ + "static/media/careers.a38d96a7.png";